import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";

export function BankCombobox({ value, onChange, banks = [], placeholder = "Select bank", testid = "bank-combobox" }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const q = query.trim().toLowerCase();
  const filtered = q ? banks.filter((b) => b.toLowerCase().includes(q)) : banks;
  const exact = banks.some((b) => b.toLowerCase() === q);

  const pick = (v) => { onChange(v); setOpen(false); setQuery(""); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between font-normal", !value && "text-muted-foreground")}
          data-testid={testid}
        >
          <span className="truncate">{value || placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Search or type a bank…" value={query} onValueChange={setQuery} data-testid={`${testid}-input`} />
          <CommandList>
            {filtered.length === 0 && !query && <CommandEmpty>No banks found.</CommandEmpty>}
            {filtered.length > 0 && (
              <CommandGroup heading="Banks">
                {filtered.map((b) => (
                  <CommandItem key={b} value={b} onSelect={() => pick(b)} data-testid={`${testid}-option-${b}`}>
                    <Check className={cn("mr-2 h-4 w-4", value === b ? "opacity-100" : "opacity-0")} />
                    {b}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {query && !exact && (
              <CommandGroup>
                <CommandItem value={`__add__${query}`} onSelect={() => pick(query.trim())} data-testid={`${testid}-add`}>
                  <Plus className="mr-2 h-4 w-4" /> Add “{query.trim()}”
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default BankCombobox;
